/* eslint-disable no-const-assign */
/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
/* eslint-disable dot-notation */
/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-const */
/* eslint-disable comma-spacing */
/* eslint-disable quotes */
/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Table, Form, Modal, Spin, notification, Tooltip, Typography, Input, Button } from 'antd';
import { Button as CrcButton, Spinner } from '@crc-evans/ui-components';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  DeleteOutlined,
  EditOutlined,
  HeatMapOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from '@ant-design/icons';
import { Plus } from 'lucide-react';
import AddNewDocControlUser from './AddNewDocControlUser';
import { GetTableConfig, DeleteDetails } from '../../redux/calibration/saga';
import { fetchDocControlList } from '../../redux/calibration/action';
import '../../pages/technical/HeatProfilePage.css';
import { useHeatStyleColumnFacets } from '../technical/heatStyleColumnFacets';

const { Title, Text } = Typography;

const DOC_CONTROL_FACET_KEYS = ['UserName', 'Location', 'documentType', 'Email'];

const DocControlMangement = (props) => {
  const { docControlData, isDocCOntrolLoading, onFetchDocList } = props;

  const [isEdit, setIsEdit] = useState(false);
  const [editRecord, seteditRecord] = useState('');
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState('');
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [uniqueLocations, setUniqueLocations] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [userForm] = Form.useForm();
  const [totalUsers, setTotalUsers] = useState(0);
  const [userModalVisible, setUserModalVisible] = useState(false);

  const DOC_CONTROL_SEARCH_INITIAL = {
    sno: '',
    UserName: '',
    Location: '',
    documentType: '',
    Email: '',
  };
  const [colSearch, setColSearch] = useState(DOC_CONTROL_SEARCH_INITIAL);
  const [sortKey, setSortKey] = useState('UserName');
  const [sortDesc, setSortDesc] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [tablePageSize, setTablePageSize] = useState(10);

  const updateColSearch = useCallback((field, value) => {
    setColSearch((prev) => ({ ...prev, [field]: value }));
  }, []);

  const docControlFacetListRef = useRef([]);
  docControlFacetListRef.current = userData || [];
  const fetchDocControlFacetRows = useCallback(async () => {
    const list = docControlFacetListRef.current;
    return Array.isArray(list) ? list : [];
  }, []);

  const searchCriteriaDocControlFacets = useMemo(() => ({}), []);

  const { applyFacetClientFilter, renderTextColumnFilterTrigger } = useHeatStyleColumnFacets({
    enabled: true,
    filterableColumns: DOC_CONTROL_FACET_KEYS,
    listCount: (userData || []).length,
    projectList: userData || [],
    searchCriteria: searchCriteriaDocControlFacets,
    columnFilters: colSearch,
    onColumnFilterChange: updateColSearch,
    fetchFacetRows: fetchDocControlFacetRows,
  });

  const handleSortClick = useCallback((field) => {
    setSortKey((prev) => {
      if (prev === field) {
        setSortDesc((d) => !d);
        return prev;
      }
      setSortDesc(false);
      return field;
    });
  }, []);

  const showDeleteModal = useCallback((record) => {
    setIsDeleteModalVisible(true);
    setSelectedData(record);
  }, []);

  const onUpdateClick = useCallback((record) => {
    setIsEdit(true);
    seteditRecord(record);
    setUserModalVisible(true);
  }, []);

  const tableDataSource = useMemo(() => {
    let list = [...(userData || [])];
    const lc = (v) => (v == null ? '' : String(v)).trim().toLowerCase();

    if (colSearch.sno.trim()) {
      const q = colSearch.sno.trim();
      list = list.filter((r) => String(r.sno ?? '').includes(q));
    }
    if (colSearch.UserName.trim()) {
      const q = lc(colSearch.UserName);
      list = list.filter((r) => lc(r.UserName).includes(q));
    }
    if (colSearch.Location.trim()) {
      const q = lc(colSearch.Location);
      list = list.filter((r) => lc(r.Location).includes(q));
    }
    if (colSearch.documentType.trim()) {
      const q = lc(colSearch.documentType);
      list = list.filter((r) => lc(r.documentType).includes(q));
    }
    if (colSearch.Email.trim()) {
      const q = lc(colSearch.Email);
      list = list.filter((r) => lc(r.Email).includes(q));
    }

    list = applyFacetClientFilter(list);

    list.sort((a, b) => {
      if (sortKey === 'sno') {
        const va = Number(a.sno) || 0;
        const vb = Number(b.sno) || 0;
        return sortDesc ? vb - va : va - vb;
      }
      const va = (a[sortKey] ?? '').toString();
      const vb = (b[sortKey] ?? '').toString();
      const cmp = va.localeCompare(vb, undefined, { sensitivity: 'base' });
      return sortDesc ? -cmp : cmp;
    });
    return list;
  }, [userData, colSearch, sortKey, sortDesc, applyFacetClientFilter]);

  useEffect(() => {
    setTablePage(1);
  }, [colSearch, userData]);

  const renderSortCaretDoc = useCallback(
    (field) =>
      sortKey === field ? (
        sortDesc ? (
          <CaretDownOutlined className="equipment-type-sort-dir-icon" aria-hidden />
        ) : (
          <CaretUpOutlined className="equipment-type-sort-dir-icon" aria-hidden />
        )
      ) : (
        <CaretUpOutlined
          className="equipment-type-sort-dir-icon doc-control-sort-caret-inactive"
          aria-hidden
        />
      ),
    [sortKey, sortDesc]
  );

  const makeSortableHeader = useCallback(
    (label, field) => {
      const showFacet = DOC_CONTROL_FACET_KEYS.includes(field);
      function DocControlSortableColumnHeader() {
        return (
          <div className="column-header-with-filter">
            <div className="column-header-text-wrapper spares-column-header-sortable">
              <span>{label}</span>
              <span
                className="custom-sort-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleSortClick(field);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleSortClick(field);
                  }
                }}
              >
                {renderSortCaretDoc(field)}
              </span>
              {showFacet ? renderTextColumnFilterTrigger(field) : null}
            </div>
            <div className="header-filter-input user-mgmt-header-search">
              <div className="heat-profile-inline-field-shell heat-profile-inline-field-shell--sm heat-profile-header-inline-shell">
                <Input
                  placeholder="Search..."
                  value={colSearch[field] ?? ''}
                  onChange={(e) => updateColSearch(field, e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  size="small"
                  style={{ width: '100%' }}
                />
              </div>
            </div>
          </div>
        );
      }
      DocControlSortableColumnHeader.displayName = `DocControlSortableColumnHeader(${field})`;
      return DocControlSortableColumnHeader;
    },
    [colSearch, handleSortClick, updateColSearch, renderSortCaretDoc, renderTextColumnFilterTrigger]
  );

  const columns = useMemo(
    () => [
      {
        title: makeSortableHeader('S.NO', 'sno'),
        dataIndex: 'ID',
        key: 'ID',
        align: 'center',
        width: 100,
        render: (text, record, index) => (tablePage - 1) * tablePageSize + index + 1,
      },
      {
        title: makeSortableHeader('NAME', 'UserName'),
        dataIndex: 'UserName',
        key: 'UserName',
        align: 'left',
        width: 220,
        ellipsis: true,
        render: (text) => <span>{text}</span>,
      },
      {
        title: makeSortableHeader('LOCATION', 'Location'),
        dataIndex: 'Location',
        key: 'Location',
        align: 'left',
        width: 160,
        ellipsis: true,
      },
      {
        title: makeSortableHeader('DOCUMENT TYPE', 'documentType'),
        dataIndex: 'documentType',
        key: 'documentType',
        align: 'left',
        width: 160,
        ellipsis: true,
      },
      {
        title: makeSortableHeader('EMAIL', 'Email'),
        dataIndex: 'Email',
        key: 'Email',
        align: 'left',
        width: 260,
        ellipsis: true,
      },
      {
        title: <span className="equipment-type-column-title">ACTIONS</span>,
        key: 'actions',
        width: 120,
        align: 'center',
        render: (text, record) => {
          if (!record) return <div>-</div>;
          return (
            <div className="heat-profile-actions-cell">
              <Tooltip title="Edit">
                <EditOutlined className="txtIcon" onClick={() => onUpdateClick(record)} />
              </Tooltip>
              <Tooltip title="Delete">
                <DeleteOutlined className="txtIcon" onClick={() => showDeleteModal(record)} />
              </Tooltip>
            </div>
          );
        },
      },
    ],
    [makeSortableHeader, tablePage, tablePageSize, onUpdateClick, showDeleteModal, renderTextColumnFilterTrigger]
  );

  useEffect(() => {
    (async () => {
      if (userData.length == 0) await fetchData();
    })();
  }, []);

  const fetchData = async () => {
    setShowLoader(true);
    const res = await GetTableConfig('UserManagement_DocControl');
    if (res && res.length > 0) {
      // Remove duplicates based on the Location property
      const uniqueLocations = res.filter(
        (item, index, self) => self.findIndex((obj) => obj.Location === item.Location) === index
      );
      res.map((item, i) => {
        item.sno = i + 1;
      });
      setUserData(res);
      setUniqueLocations(uniqueLocations);
    }
    setShowLoader(false);
  };

  const showAddUserModal = async () => {
    setUserModalVisible(true);
  };

  /** Deleting Spare parts data on confirm */
  const handleDeleteOk = async () => {
    {
      setIsDeleteLoading(true);
      const obj = {
        columnName: 'UserManagement_DocControl',
        tableName: 'UserManagement_DocControl',
        data: selectedData,
      };
      await DeleteDetails(obj);

      setSelectedData('');
      await fetchData();
      setIsDeleteLoading(false);
      setIsDeleteModalVisible(false);
    }
  };

  /** Cancelling the deletion of spare parts data */
  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
  };

  return (
    <div className="heat-profile-content-wrapper">
      <div className="heat-profile-card">
        {/* Header - matches HeatProfile layout */}
        <div className="heat-profile-list-header">
          <div className="heat-profile-header-left">
            <div className="heat-profile-icon-wrap">
              <HeatMapOutlined style={{ fontSize: 22 }} />
            </div>
            <div className="heat-profile-header-content">
              <div className="heat-profile-title-row">
                <h3 className="heat-profile-list-title">
                  List of Calibration & Control Users
                </h3>
                <span className="heat-profile-summary">
                  {tableDataSource.length} item{tableDataSource.length !== 1 ? 's' : ''}
                </span>
              </div>
              <p className="heat-profile-list-description">
                Manage users for calibration and document control access.
              </p>
            </div>
          </div>
          <div className="heat-profile-header-actions calibration-modern-actions">
            <CrcButton
              label="Add New"
              variant="primary"
              icon={Plus}
              onClick={() => showAddUserModal()}
              size="small"
            />
          </div>
        </div>

        {/* Table - matches HeatProfile layout */}
        <div className="addTeamDetails heat-profile-table-wrap">
          <Table
            columns={columns}
            dataSource={tableDataSource}
            className="h-100 pipeline-table equipPaginationTable heat-profile-table equipment-types-table doc-control-users-table"
            scroll={{ x: 1100, y: 'calc(100vh - 280px)' }}
            loading={{
              spinning: showLoader,
              indicator: <Spinner variant="inline" size="large" color="#00C9A7" />,
            }}
            rowKey={(record) => record.ID || record.sno}
            pagination={
              tableDataSource.length > 10
                ? {
                  current: tablePage,
                  pageSize: tablePageSize,
                  total: tableDataSource.length,
                  position: ['bottomRight'],
                  showSizeChanger: true,
                  className: 'heat-profile-pagination',
                  pageSizeOptions: ['10', '20', '50', '100'],
                  onChange: (p, ps) => {
                    setTablePage(p);
                    if (ps) setTablePageSize(ps);
                  },
                }
                : false
            }
          />
        </div>
      </div>

      {userModalVisible && (
        <AddNewDocControlUser
          userModalVisible={userModalVisible}
          setUserModalVisible={setUserModalVisible}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          editRecord={editRecord}
          fetchData={fetchData}
          uniqueLocations={uniqueLocations}
          setUniqueLocations={setUniqueLocations}
        ></AddNewDocControlUser>
      )}

      <Modal
        width="45vw"
        className="heatprofile-modal"
        title="Delete Details"
        centered
        visible={isDeleteModalVisible}
        onCancel={handleDeleteCancel}
        footer={[
          <Button key="cancel" onClick={handleDeleteCancel}>
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleDeleteOk}
            loading={isDeleteLoading}
          >
            {isDeleteLoading ? 'Deleting...' : 'Delete'}
          </Button>,
        ]}
      >
        <div style={{ padding: '24px 0', fontSize: '16px', color: '#1B1516' }}>
          <p>Deleting all the corresponding and related information.</p>
          Are you sure you want to delete?
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ calibrationReducer }) => {
  const docControlData = get(calibrationReducer, 'docControlData', []);
  const isDocCOntrolLoading = get(calibrationReducer, 'isDocCOntrolLoading', false);

  return {
    docControlData,
    isDocCOntrolLoading,
  };
};

const mapDispatchToProps = {
  onFetchDocList: fetchDocControlList,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocControlMangement);
